export { en } from './en';
export { pt } from './pt';
export { de } from './de';
export type { Language, Translations, CompanyDescription, CompanyHighlight } from './types';

import { en } from './en';
import { pt } from './pt';
import { de } from './de';
import type { Language, Translations } from './types';

export const translations: Record<Language, Translations> = { en, pt, de };
